export enum EmailNotificationPreference {
    Unspecified = 0,
    NoInformationEmails = 1
}